import type { ReactNode } from 'react';

import { FaIcon } from './icons/FaIcon';

export type PanelInfoWithIconProps = {
  icon?: string;
  text?: string;
  children?: ReactNode;
  cssClass?: string;
  textCssClass?: string;
  testID?: string;
};

export function PanelInfoWithIcon({
  icon,
  text,
  children,
  cssClass,
  textCssClass,
  testID,
}: PanelInfoWithIconProps) {
  return (
    <div
      className={`panel-info-with-icon d-flex flex-column gap-2 align-content-center justify-content-center align-items-center w-100 h-100 small ${cssClass ?? ''}`}
    >
      {icon != null && (
        <div className="mt-1">
          <FaIcon icon={icon} size="xxl" cssClass="text-black-50" />
        </div>
      )}

      {text != null && (
        <div className={`panel-info-with-icon__text small ${textCssClass ?? ''}`} data-testid={testID}>
          {text}
        </div>
      )}

      {children}
    </div>
  );
}
